




















































































































import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ConfigsService from "@/services/api/configs.service";
import { BaseSideComponent } from "@/components/structure/MixinsSideComponent";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { UsersService } from "@/services/api/users.service";
import { CurrentUser } from "@/models/auth/current.user";
import { CreateUserCommand } from "@/server/app.commands";
import {
  AppGroupDto,
  LanguageDto,
  MetadataConfiguration,
  UserTypeDto
} from "@/server/app.dtos";
import { UserTypesService } from "@/services/api/user.types.service";
import { GetUserTypeMetadataGroupsConfigurationDtoQuery } from "@/server/app.queries";
import { GenerateMetadataComposer } from "@/utilities/helpers";
import nationalities from "@/models/storage/nationalities";

@Component
export default class CreateUserSideMenuComponent extends BaseSideComponent {
  @Getter("iduser") iduser!: CurrentUser;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  configsService: ConfigsService = new ConfigsService();
  usersService: UsersService = new UsersService();
  userTypesService: UserTypesService = new UserTypesService();
  instance: CreateUserCommand = new CreateUserCommand();
  nationalities: string[] = nationalities;
  userTypes: UserTypeDto[] | null = null;
  appGroups: AppGroupDto[] | null = null;
  metadataConfiguration: MetadataConfiguration | null = null;
  isLoading: boolean = false;
  isValid: boolean = false;

  @Watch("instance.idUserType")
  async onChangeIdUserType() {
    await this.loadMetadataconfiguration();
  }

  async onCreateUser() {
    if (this.isLoading || !this.isValid) return;
    this.isLoading = true;

    if (this.metadataConfiguration != null) {
      this.instance.metadata = GenerateMetadataComposer(
        this.metadataConfiguration
      ).metadata;
    }

    await this.usersService
      .Create(this.instance)
      .then((id: number) => {
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.$router.push(`/user/${id}`);
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }

  async created() {
    const query: string = "IdLanguage=" + this.currentLanguage.idLanguage;

    // Load User Types
    await this.configsService.Load("api/userTypes", query).then(result => {
      this.userTypes = result;
    });

    // Load App Groups
    await this.configsService.Load("api/appgroups", query).then(result => {
      this.appGroups = result;
    });
  }

  async loadMetadataconfiguration() {
    const query = new GetUserTypeMetadataGroupsConfigurationDtoQuery();
    query.idLanguage = this.currentLanguage.idLanguage;
    query.idUserType = this.instance.idUserType;
    query.visibleOnCreate = true;
    await this.userTypesService
      .GetMetadataGroupsConfiguration(query)
      .then(
        (result: MetadataConfiguration) => (this.metadataConfiguration = result)
      )
      .catch(() => (this.metadataConfiguration = null));
  }
}
